/* Built from src/ by tools/build-asset.mjs — do not edit in the theme. */
(function (root) {
  var RMC = root.RMC || (root.RMC = {});

  // The catalogue carries merchant-typed prices: bare numbers, but also
  // "No charge" and "Ask your dealer". parseFloat on those yields NaN, and a
  // single NaN in the sum makes every figure on the page read NaN with no clue
  // where it came from. Anything that is not a number is worth zero.
  RMC.price = function (v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/[$,]/g, ''));
    return isFinite(n) ? n : 0;
  };

  RMC.emptyBuild = function (model) { return { model: model, qty: {}, text: {} }; };

  // How a price reads on the page. A credit is money back, so it gets a real
  // minus sign and the same currency formatting as everything else — left raw
  // it printed as "-7120" beside prices written "+$1,900".
  RMC.money = function (n) { return '$' + Math.round(Math.abs(n)).toLocaleString('en-US'); };
  RMC.priceLabel = function (price) {
    var p = RMC.price(price);
    if (p > 0) { return '+' + RMC.money(p); }
    if (p < 0) { return '\u2212' + RMC.money(p); }
    return String(price == null ? '' : price) || 'No charge';
  };

  // Custom work — "walnut, oiled" for flooring, a fabric name for upholstery —
  // rides on the build as written text so it reaches the sheet. The shop's
  // material-change charge for that line is real money and totals() counts it,
  // but only once the customer has written what they want: an empty field is
  // not an order for anything. A line priced in words ("Quoted") adds nothing.
  RMC.setText = function (build, optionId, value) {
    if (!build.text) { build.text = {}; }
    var v = String(value == null ? '' : value).trim();
    if (v === '') { delete build.text[optionId]; } else { build.text[optionId] = v; }
    return { ok: true };
  };

  RMC.groupCount = function (build, groupId, catalog) {
    var n = 0, qty = (build && build.qty) || {};
    for (var id in qty) {
      var opt = catalog.options[id];
      if (opt && opt.group === groupId) { n += qty[id]; }
    }
    return n;
  };

  RMC.totals = function (build, catalog, basePrice) {
    var base = RMC.price(basePrice), up = 0, qty = (build && build.qty) || {};
    for (var id in qty) {
      var opt = catalog.options[id];
      if (opt) { up += RMC.price(opt.price) * qty[id]; }
    }
    // The material-change charge is flat — it is the cost of interrupting a
    // production line to fit something different, not a per-unit price — so it
    // is added once per written request and never multiplied.
    var text = (build && build.text) || {};
    for (var tid in text) {
      if (!String(text[tid] == null ? '' : text[tid]).trim()) { continue; }
      var topt = catalog.options[tid];
      if (topt) { up += RMC.price(topt.price); }
    }
    return { base: base, upgrades: up, total: base + up };
  };
  // The cap belongs to the pair (group, model), not to the group. Boxes are one
  // list to the customer, but the Loft takes two and the Bajas take three, and
  // splitting the group to express that would split the list on the page too.
  RMC.capFor = function (catalog, groupId, model) {
    var g = catalog && catalog.groups && catalog.groups[groupId];
    if (!g) { return null; }
    if (g.caps && g.caps[model] != null) { return g.caps[model]; }
    return g.cap == null ? null : g.cap;
  };

  // A Loft box bolts to a Molle panel, so the panel is a precondition. The rule
  // is written on the box group but must not reach the Bajas, which have boxes
  // and no panels at all — on a rig where the needed group is empty there is
  // nothing to require, so the requirement does not exist.
  RMC.needsMet = function (build, catalog, groupId, model) {
    var g = catalog.groups[groupId];
    if (!g || !g.needs) { return true; }
    if (!RMC.groupHasOptionsFor(catalog, g.needs, model)) { return true; }
    return RMC.groupCount(build, g.needs, catalog) > 0;
  };

  RMC.dependentsOn = function (catalog, groupId) {
    var out = [];
    for (var gid in catalog.groups) {
      if (catalog.groups[gid].needs === groupId) { out.push(gid); }
    }
    return out;
  };

  RMC.setQty = function (build, optionId, n, catalog) {
    var opt = catalog.options[optionId];
    if (!opt) { return { ok: false, reason: 'unknown option' }; }
    n = Math.max(0, Math.floor(n));
    var gid = opt.group;
    var model = build && build.model;
    var have = (build.qty && build.qty[optionId]) || 0;

    if (gid && n > have && !RMC.needsMet(build, catalog, gid, model)) {
      return { ok: false, reason: 'needs', group: catalog.groups[gid].needs };
    }
    if (gid) {
      // The cap is on the GROUP, not the line: three wedge boxes is legal,
      // two wedge boxes plus two ski boxes is not.
      var cap = RMC.capFor(catalog, gid, model);
      if (cap != null) {
        var others = RMC.groupCount(build, gid, catalog) - have;
        if (others + n > cap) { return { ok: false, reason: 'cap' }; }
      }
      // Taking the last panel off would leave boxes mounted to nothing. Clearing
      // them silently would delete thousands of dollars of someone's build
      // without asking, so the removal is refused and the page says why.
      if (n < have && RMC.groupCount(build, gid, catalog) - have + n === 0) {
        var deps = RMC.dependentsOn(catalog, gid);
        for (var i = 0; i < deps.length; i++) {
          if (RMC.groupCount(build, deps[i], catalog) > 0) {
            return { ok: false, reason: 'needed-by', group: deps[i] };
          }
        }
      }
    }
    if (n === 0) { delete build.qty[optionId]; } else { build.qty[optionId] = n; }
    return { ok: true };
  };

  RMC.choose = function (build, groupId, optionId, catalog) {
    for (var id in build.qty) {
      var o = catalog.options[id];
      if (o && o.group === groupId) { delete build.qty[id]; }
    }
    if (optionId) { build.qty[optionId] = 1; }
    return { ok: true };
  };

  // The swatch a rig ships with: the first one in the group that costs nothing.
  // A group where every colour is priced has no standard, and stays optional.
  RMC.standardOf = function (catalog, groupId, model) {
    var g = catalog && catalog.groups && catalog.groups[groupId];
    if (!g || g.kind !== 'swatch') { return null; }
    var ids = catalog.order || Object.keys(catalog.options);
    for (var i = 0; i < ids.length; i++) {
      var o = catalog.options[ids[i]];
      if (!o || o.group !== groupId) { continue; }
      var m = o.models || ['all'];
      if (m.indexOf('all') < 0 && m.indexOf(model) < 0) { continue; }
      if (RMC.price(o.price) <= 0) { return o.id; }
    }
    return null;
  };

  // Shows the standard as chosen rather than leaving the group blank, because a
  // blank group reads as "not decided yet" when it actually means "the floor it
  // comes with". Never overrules a colour already on the build.
  RMC.applyStandards = function (build, catalog, model) {
    for (var gid in catalog.groups) {
      if (catalog.groups[gid].kind !== 'swatch') { continue; }
      if (RMC.groupCount(build, gid, catalog) > 0) { continue; }
      var std = RMC.standardOf(catalog, gid, model);
      if (std) { build.qty[std] = 1; }
    }
    return build;
  };

  // There is always a floor. Picking the one already picked falls back to the
  // standard instead of clearing the group, which would claim no flooring.
  RMC.chooseSwatch = function (build, groupId, optionId, catalog, model) {
    var already = optionId && build.qty[optionId];
    var std = RMC.standardOf(catalog, groupId, model);
    var target = already ? (std && std !== optionId ? std : (std ? std : null)) : optionId;
    if (already && std === optionId) { return { ok: true }; }   // the standard stays put
    return RMC.choose(build, groupId, target, catalog);
  };

  RMC.toggle = function (build, optionId, catalog) {
    return RMC.setQty(build, optionId, build.qty[optionId] ? 0 : 1, catalog);
  };
  RMC.customerFields = ['firstname', 'lastname', 'phone', 'email'];

  // A required choice group is only required for a model that HAS options in it.
  // Floorplan exists for the Loft and the Bajas but not the Havn or the Skye, so
  // requiring it unconditionally blocks export forever on two of the five rigs —
  // the customer is told to answer a question the page never asks them.
  RMC.validateBuild = function (build, catalog, model) {
    var missing = [];
    for (var gid in catalog.groups) {
      var g = catalog.groups[gid];
      if (g.kind !== 'choice' || !g.required) { continue; }
      if (!RMC.groupHasOptionsFor(catalog, gid, model)) { continue; }
      if (RMC.groupCount(build, gid, catalog) === 0) { missing.push(g.title || gid); }
    }
    return { ok: missing.length === 0, missing: missing };
  };

  RMC.groupHasOptionsFor = function (catalog, groupId, model) {
    var ids = catalog.order || Object.keys(catalog.options);
    for (var i = 0; i < ids.length; i++) {
      var o = catalog.options[ids[i]];
      if (!o || o.group !== groupId) { continue; }
      var m = o.models || ['all'];
      if (m.indexOf('all') > -1 || m.indexOf(model) > -1) { return true; }
    }
    return false;
  };

  // Blocked for a missing floorplan is a different failure from blocked for a
  // missing email, and the customer has to be told which — so the groups come
  // back separately rather than mixed into one list of strings.
  // The two reasons an export is blocked are different jobs in different places:
  // the choices live out on the page, the contact details live in the dialog.
  // One merged list of names reads as a single unexplained failure.
  RMC.exportBlocked = function (v, labels) {
    if (!v || v.ok) { return []; }
    var out = [];
    var groups = v.groups || [];
    if (groups.length) {
      var names = groups.length > 1
        ? groups.slice(0, -1).join(', ') + ' and ' + groups[groups.length - 1]
        : groups[0];
      out.push('Choose a ' + names + ' on the page first.');
    }
    var fields = (v.missing || []).filter(function (m) { return groups.indexOf(m) < 0; });
    if (fields.length) {
      out.push('Still needed here: ' + fields.map(function (f) {
        return (labels && labels[f]) || f;
      }).join(', ') + '.');
    }
    return out;
  };

  RMC.validateExport = function (build, catalog, model, customer) {
    var v = RMC.validateBuild(build, catalog, model);
    var missing = v.missing.slice();
    RMC.customerFields.forEach(function (f) {
      if (!customer || !String(customer[f] || '').trim()) { missing.push(f); }
    });
    return { ok: missing.length === 0, missing: missing, groups: v.missing };
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  var RMC = root.RMC || (root.RMC = {});

  // "&" becomes "and" rather than a separator. Collapsing it to a hyphen made
  // "Spare Tire Carrier" and "Spare Tire & Carrier" — two different products at
  // two different prices — the same id, and the Loft silently lost its $1,649
  // option. Any punctuation that carries meaning in a product name belongs here.
  RMC.slug = function (s) {
    return String(s).toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  };

  // Line format: Name | Price | Models | Description | Note | Image
  // Field 6 was documented as "Group" and never read — buildCatalog overwrites
  // it with the block's own id on every option — so it now carries the swatch
  // image filename instead. No line in the live catalogue had ever filled it.
  // Price stays a string here — "No charge" and "Ask your dealer" are legal
  // values a merchant types, and RMC.price() is what turns any of them into
  // arithmetic. Coercing at parse time would throw that wording away.
  RMC.parseLine = function (line) {
    var p = String(line == null ? '' : line).split('|').map(function (x) { return x.trim(); });
    var name = p[0];
    if (!name) { return null; }
    // Model tags are slugged, not merely lowercased: a merchant types
    // "Baja Trail" but ?model=, the state keys and the switcher all speak
    // "baja-trail". Lowercasing alone leaves a space and silently drops every
    // two-word model's options from that model's list.
    var models = (p[2] || 'all').split(',')
      .map(function (m) { return RMC.slug(m); }).filter(Boolean);
    return {
      id: RMC.slug(name),
      name: name,
      price: p[1] || '',
      models: models.length ? models : ['all'],
      description: p[3] || '',
      note: p[4] || '',
      image: p[5] || ''
    };
  };

  // A requested model that is not on the page is a stale link or a typo. With
  // allowNone the page says so and asks; without it, it falls through to the
  // first model. Either way it never renders nothing.
  RMC.resolveModel = function (requested, models, opts) {
    var want = RMC.slug(requested == null ? '' : requested);
    if (models.indexOf(want) > -1) { return want; }
    return (opts && opts.allowNone) ? null : models[0];
  };
  // Two lines named alike but sold to different rigs are not a collision: both
  // survive, and no model's list lost anything. Only an overlap can overwrite.
  function sharesAModel(claimed, models) {
    for (var i = 0; i < claimed.length; i++) {
      var prior = claimed[i];
      if (prior.indexOf('all') > -1 || models.indexOf('all') > -1) { return true; }
      for (var j = 0; j < models.length; j++) {
        if (prior.indexOf(models[j]) > -1) { return true; }
      }
    }
    return false;
  }

  // The island ships raw merchant-typed lines rather than a pre-built option
  // map: Liquid would have to JSON-escape sixty names, prices and descriptions
  // by hand, and parseLine is already tested. Assemble here instead.
  RMC.buildCatalog = function (groups) {
    var catalog = { groups: {}, options: {}, order: [], duplicates: [] };
    var claimedBy = {};   // base slug -> the model lists already taken under it
    (groups || []).forEach(function (g) {
      catalog.groups[g.id] = {
        id: g.id, title: g.title, kind: g.kind || 'toggle',
        cap: g.cap == null ? null : g.cap, required: !!g.required,
        caps: g.caps || null, needs: g.needs || null, needsNote: g.needsNote || '', heldNote: g.heldNote || ''
      };
      (g.lines || []).forEach(function (line) {
        var opt = RMC.parseLine(line);
        if (!opt) { return; }              // blank lines are spacing, not products
        opt.group = g.id;
        // Ids come from names, so two products whose names slug alike collide.
        // Silently overwriting loses one of them from the page entirely — which
        // is exactly what happened to the Loft's Spare Tire Carrier — so a
        // survivor gets a numbered id instead, and the collision is reported
        // loudly enough that nobody has to notice a missing row to find it.
        var base = opt.id;
        var claimed = claimedBy[base] || (claimedBy[base] = []);
        if (catalog.options[opt.id]) {
          if (sharesAModel(claimed, opt.models) && catalog.duplicates.indexOf(base) < 0) {
            catalog.duplicates.push(base);
          }
          var n = 2;
          while (catalog.options[base + '-' + n]) { n++; }
          opt.id = base + '-' + n;
        }
        claimed.push(opt.models);
        catalog.options[opt.id] = opt;
        catalog.order.push(opt.id);
      });
    });
    return catalog;
  };

  // One slug function, one price parser, for models as well as options. The
  // Liquid side used to do its own downcase|replace and its own | plus: 0, so a
  // model named "Loft (Sprinter)" slugged two different ways and lost every
  // option, and a base price typed "$284,987" silently became 0.
  RMC.buildModels = function (rows) {
    var out = { models: [], names: {}, bases: {}, msrp: {} };
    (rows || []).forEach(function (r) {
      var name = String(r.name == null ? '' : r.name).trim();
      if (!name) { return; }
      var id = RMC.slug(name);
      out.models.push(id);
      out.names[id] = name;
      out.bases[id] = RMC.price(r.base);
      out.msrp[id] = RMC.price(r.msrp);
    });
    return out;
  };

  RMC.queryParam = function (search, name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(String(search || ''));
    if (!m) { return null; }
    // decodeURIComponent throws URIError on a malformed escape. Unguarded that
    // aborts startup before anything renders — a blank page instead of the
    // fallback the caller already has. (Shopify's edge 400s most malformed
    // query strings before they reach us, so this is belt and braces.)
    try { return decodeURIComponent(m[1]); } catch (e) { return null; }
  };

  // Where a campaign link says which rig to open on. ?model= is the contract;
  // utm_content and utm_campaign are read too, because some campaign builders
  // only let you fill the UTM boxes and a marketer should not have to hand-edit
  // a URL to get a working link.
  //
  // The match is exact against a real rig slug. "spring-loft-sale" deliberately
  // picks nothing: guessing from inside a campaign name would eventually land a
  // Baja Plus buyer on the Baja Trail, and a page that asks which rig is a much
  // better failure than a page that answers wrongly and prices the wrong one.
  RMC.modelFromQuery = function (search, models) {
    var fields = ['model', 'utm_content', 'utm_campaign'];
    for (var i = 0; i < fields.length; i++) {
      var raw = RMC.queryParam(search, fields[i]);
      if (raw == null || raw === '') { continue; }
      // a campaign builder may encode a space as "+" rather than %20
      var hit = RMC.resolveModel(String(raw).replace(/\+/g, ' '), models, { allowNone: true });
      if (hit) { return hit; }
    }
    return null;
  };

  // A description lives in one field on one line: the line format splits on "|"
  // and the block splits on newlines, so a merchant wanting a second paragraph
  // has no key they can press. A literal \n in the field asks for the break.
  RMC.paragraphs = function (text) {
    return String(text == null ? '' : text).split('\\n')
      .map(function (x) { return x.trim(); })
      .filter(Boolean);
  };

  RMC.optionsFor = function (catalog, model) {
    var out = [];
    catalog.order.forEach(function (id) {
      var o = catalog.options[id];
      if (!o) { return; }
      if (o.models.indexOf('all') > -1 || o.models.indexOf(model) > -1) { out.push(o); }
    });
    return out;
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  var RMC = root.RMC || (root.RMC = {});

  // The specs shown here are not a copy. They are read, at page load, out of
  // the rig's own vehicle page — the one place anyone edits them — so a change
  // made there for /pages/loft shows up here without a second edit. The vehicle
  // pages are untouched by any of this; they do not know we are reading them.
  //
  // Line format: Model | page path | section id
  RMC.specSources = function (text) {
    var out = {};
    String(text == null ? '' : text).split('\n').forEach(function (line) {
      var p = String(line).split('|').map(function (x) { return x.trim(); });
      if (!p[0] || !p[1]) { return; }
      out[RMC.slug(p[0])] = { path: p[1], sectionId: p[2] || '' };
    });
    return out;
  };

  // Shopify's Section Rendering API returns just that one section: 27KB rather
  // than the 417KB vehicle page. The id embeds the template's numeric id, so it
  // goes stale the day somebody recreates the template — hence a second URL.
  RMC.specUrl = function (src, full) {
    if (!src || !src.path) { return null; }
    if (full || !src.sectionId) { return src.path; }
    return src.path + (src.path.indexOf('?') > -1 ? '&' : '?') +
      'section_id=' + encodeURIComponent(src.sectionId);
  };

  // The contract with loft-spec-tabs.liquid: a button per tab, a panel per tab,
  // and inside each panel tiles that are either label/value rows or a list.
  // Image tiles (the floorplans) are deliberately left behind — the customer is
  // pricing a build here, and the floorplan is a choice further down the page.
  RMC.parseSpecs = function (docOrEl) {
    if (!docOrEl || !docOrEl.querySelectorAll) { return null; }
    var tabs = [].slice.call(docOrEl.querySelectorAll('[data-loftspec-tab]'));
    var panels = [].slice.call(docOrEl.querySelectorAll('[data-loftspec-panel]'));
    if (!panels.length) { return null; }
    var out = panels.map(function (panel, i) {
      return {
        label: tabs[i] ? tabs[i].textContent.trim() : ('Specs ' + (i + 1)),
        tiles: [].slice.call(panel.querySelectorAll('.loftspec__tile'))
          .map(readTile).filter(Boolean)
      };
    }).filter(function (t) { return t.tiles.length; });
    return out.length ? out : null;
  };

  function readTile(tile) {
    var h = tile.querySelector('h4');
    var title = h ? h.textContent.trim() : '';
    var rows = [].slice.call(tile.querySelectorAll('.loftspec__row')).map(function (r) {
      var s = r.querySelectorAll('span');
      return [s[0] ? s[0].textContent.trim() : '', s[1] ? s[1].textContent.trim() : ''];
    }).filter(function (r) { return r[0] || r[1]; });
    if (rows.length) { return { title: title, rows: rows }; }
    var items = [].slice.call(tile.querySelectorAll('li'))
      .map(function (li) { return li.textContent.trim(); })
      .filter(Boolean);
    return items.length ? { title: title, items: items } : null;
  }

  // Resolves to the specs, or to null — never rejects. A rig whose specs cannot
  // be reached falls back to the transcribed feature list, which is worse but is
  // not nothing, and that decision belongs to the caller, not to a rejection it
  // has to remember to catch.
  RMC.loadSpecs = function (src, opts) {
    opts = opts || {};
    var f = opts.fetch || root.fetch;
    var extract = opts.extract || function (html) {
      return RMC.parseSpecs(new root.DOMParser().parseFromString(html, 'text/html'));
    };
    var urls = [RMC.specUrl(src, false), RMC.specUrl(src, true)]
      .filter(Boolean)
      .filter(function (u, i, a) { return a.indexOf(u) === i; });
    if (!urls.length || typeof f !== 'function') { return Promise.resolve(null); }

    var i = 0;
    function attempt() {
      if (i >= urls.length) { return Promise.resolve(null); }
      var url = urls[i++];
      return f(url, { credentials: 'same-origin' })
        .then(function (r) { return r && r.ok ? r.text() : null; })
        .then(function (html) {
          var specs = html ? extract(html) : null;
          return (specs && specs.length) ? specs : attempt();
        })
        .catch(function () { return attempt(); });
    }
    return attempt();
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  var RMC = root.RMC || (root.RMC = {});

  // HubSpot's own form endpoint. It takes a portal id and a form guid, neither
  // of which is a secret, which is the whole reason this can run in the
  // customer's browser: a private-app token never goes near the theme.
  // The host is regional and the path is /submissions/, not /submit/. An na2
  // account does not answer on api.hsforms.com at all — both the old host and
  // the old path return a 404 HTML page, which a fire-and-forget POST would
  // swallow in silence while every lead went nowhere.
  RMC.hubspotUrl = function (portal, form, region) {
    portal = String(portal || '').trim();
    form = String(form || '').trim();
    region = String(region || '').trim().toLowerCase();
    if (!portal || !form) { return null; }      // unconfigured is off, not broken
    var host = region ? 'forms-' + region + '.hsforms.com' : 'forms.hsforms.com';
    return 'https://' + host + '/submissions/v3/integration/submit/' +
      encodeURIComponent(portal) + '/' + encodeURIComponent(form);
  };

  // Our field names are the ones on the order sheet; HubSpot's are whatever the
  // form was built with. This form wants "mobilephone" where we say "phone",
  // and a name the form does not have is dropped without comment.
  // Line format: ourName | hubspotPropertyName
  RMC.fieldMap = function (text) {
    var out = {};
    String(text == null ? '' : text).split('\n').forEach(function (line) {
      var p = String(line).split('|');
      if (p.length < 2) { return; }
      var from = p[0].trim(), to = p[1].trim();
      if (from && to) { out[from] = to; }
    });
    return out;
  };

  // The visitor's HubSpot cookie. Sending it is what ties this submission to
  // the session HubSpot already knows about, so the lead keeps the source that
  // actually brought them here instead of being attributed to nothing.
  RMC.cookie = function (name, jar) {
    var m = new RegExp('(?:^|;\\s*)' + String(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
      '=([^;]*)').exec(String(jar == null ? '' : jar));
    return m ? m[1] : '';
  };

  // What the salesperson opening the record needs to see: which rig, what is on
  // it, and what it comes to. The written requests carry their charge, because
  // on the sheet they do too.
  RMC.buildSummary = function (ctx) {
    var money = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };
    var t = RMC.totals(ctx.build, ctx.catalog, ctx.base);
    var lines = [(ctx.name || ctx.model) + ' — ' + money(t.base) + ' before options'];
    RMC.optionsFor(ctx.catalog, ctx.model).forEach(function (o) {
      var n = ctx.build.qty[o.id];
      if (!n) { return; }
      var p = RMC.price(o.price) * n;
      lines.push('- ' + (n > 1 ? n + ' × ' : '') + o.name +
        (p === 0 ? ': ' + (o.price || 'No charge') : ' ' + RMC.priceLabel(String(p))));
    });
    RMC.optionsFor(ctx.catalog, ctx.model).forEach(function (o) {
      var txt = ctx.build.text && ctx.build.text[o.id];
      if (!txt) { return; }
      // A price the shop wrote in words is a rule the salesperson needs as much
      // as the customer does — the Loft's toilet is free unless it draws power —
      // so a worded price rides along instead of printing nothing. A real
      // figure, charge or credit, formats the same way it does on the sheet.
      var p = RMC.price(o.price);
      var tail = p === 0
        ? (o.price ? ' \u2014 ' + o.price : '')
        : ' ' + RMC.priceLabel(o.price);
      lines.push('- ' + o.name + ': ' + txt + tail);
    });
    lines.push('Total ' + money(t.total));
    return lines.join('\n');
  };

  RMC.hubspotPayload = function (customer, ctx, opts) {
    opts = opts || {};
    var map = opts.fieldMap || {};
    var fields = RMC.customerFields.map(function (f) {
      return { objectTypeId: '0-1', name: map[f] || f,
               value: String((customer || {})[f] || '').trim() };
    });
    // Only sent where the merchant has named a real HubSpot property: inventing
    // a field name would make every submission fail validation, silently.
    if (opts.modelField) {
      // HubSpot's Model property is a fixed-option dropdown. "2027 Havn" is
      // stored, "Havn" is discarded without complaint — the submission succeeds
      // and the field simply arrives empty. A rig with no matching option is
      // left out rather than sent to be thrown away.
      var rig = ctx.name || ctx.model || '';
      var value = opts.modelMap ? (opts.modelMap[rig] || '') : rig;
      if (value) { fields.push({ objectTypeId: '0-1', name: opts.modelField, value: value }); }
    }
    if (opts.buildField) {
      fields.push({ objectTypeId: '0-1', name: opts.buildField, value: RMC.buildSummary(ctx) });
    }
    var context = { pageUri: opts.pageUri || '', pageName: opts.pageName || '' };
    // HubSpot rejects the whole submission on an empty hutk rather than ignoring it
    if (opts.hutk) { context.hutk = opts.hutk; }
    return { fields: fields, context: context };
  };

  // A second, independent delivery: HubSpot gets the contact, sales@ gets the
  // build. It is deliberately separate from submitLead so that neither can stop
  // the other, and neither can stop the customer printing — the CRM record and
  // the sheet are what the submission is for, the email is a convenience.
  RMC.notifySales = function (customer, ctx, opts) {
    opts = opts || {};
    var url = String(opts.url || '').trim();
    if (!url) { return Promise.resolve({ ok: false, reason: 'not configured' }); }
    var missing = RMC.customerFields.filter(function (f) {
      return !String((customer || {})[f] || '').trim();
    });
    if (missing.length) {
      return Promise.resolve({ ok: false, reason: 'incomplete', missing: missing });
    }
    var f = opts.fetch || root.fetch;
    if (typeof f !== 'function') { return Promise.resolve({ ok: false, reason: 'no fetch' }); }
    var t = RMC.totals(ctx.build, ctx.catalog, ctx.base);
    return f(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstname: customer.firstname, lastname: customer.lastname,
        email: customer.email, phone: customer.phone,
        rig: opts.rig || ctx.name || ctx.model || '',
        total: '$' + Math.round(t.total).toLocaleString('en-US'),
        summary: RMC.buildSummary(ctx),
        pageUrl: opts.pageUrl || ''
      })
    }).then(function (r) {
      return r && r.ok ? { ok: true } : { ok: false, status: r && r.status };
    }).catch(function (e) {
      return { ok: false, reason: (e && e.message) || 'failed' };
    });
  };

  // Resolves either way and never throws. A lead that does not reach HubSpot
  // must not stop the customer printing the sheet they came for — the sheet is
  // the thing they can act on, the CRM record is ours.
  RMC.submitLead = function (customer, ctx, opts) {
    opts = opts || {};
    var url = RMC.hubspotUrl(opts.portal, opts.form, opts.region);
    if (!url) { return Promise.resolve({ ok: false, reason: 'not configured' }); }
    var missing = RMC.customerFields.filter(function (f) {
      return !String((customer || {})[f] || '').trim();
    });
    if (missing.length) {
      return Promise.resolve({ ok: false, reason: 'incomplete', missing: missing });
    }
    var f = opts.fetch || root.fetch;
    if (typeof f !== 'function') { return Promise.resolve({ ok: false, reason: 'no fetch' }); }
    return f(url, {
      method: 'POST',
      // keepalive: the click that sends this also calls window.print(), which
      // blocks the page. Without it the browser is entitled to drop a request
      // still in flight, and the lead vanishes exactly when someone exports.
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(RMC.hubspotPayload(customer, ctx, opts))
    }).then(function (r) {
      return r && r.ok ? { ok: true } : { ok: false, status: r && r.status };
    }).catch(function (e) {
      return { ok: false, reason: (e && e.message) || 'failed' };
    });
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  var RMC = root.RMC || (root.RMC = {});
  var KEY = 'rm-configurator-v1';

  // Private windows and locked-down browsers THROW on storage access rather
  // than returning null — and in some the `localStorage` property getter itself
  // throws, so the object may never arrive here at all. An unguarded read takes
  // the whole configurator down for that visitor, so every access is wrapped
  // and failure is silent: a lost saved build is an inconvenience, a dead page
  // is a lost customer.
  RMC.loadState = function (storage) {
    try {
      if (!storage) { return {}; }
      var raw = storage.getItem(KEY);
      if (!raw) { return {}; }
      var parsed = JSON.parse(raw);
      return (parsed && typeof parsed === 'object') ? parsed : {};
    } catch (e) { return {}; }
  };

  RMC.saveState = function (state, storage) {
    try {
      if (!storage) { return; }
      storage.setItem(KEY, JSON.stringify(state));
    } catch (e) { /* quota, private mode, disabled — none of them fatal */ }
  };

  // A merchant can delete an option in the theme editor while a customer has it
  // saved. Keeping the stale id would price a product that no longer exists.
  RMC.pruneBuild = function (build, catalog) {
    var out = { model: build.model, qty: {}, text: {} };
    for (var id in build.qty) {
      if (catalog.options[id]) { out.qty[id] = build.qty[id]; }
    }
    var text = build.text || {};
    for (var tid in text) {
      if (catalog.options[tid]) { out.text[tid] = text[tid]; }
    }
    return out;
  };
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  var RMC = root.RMC || (root.RMC = {});

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }

  function image(src, cls, alt) {
    var n = document.createElement('img');
    n.className = cls; n.src = src; n.alt = alt || '';
    return n;
  }

  function money(n) { return RMC.money(n); }

  function signOf(n) { return n > 0 ? '+' : (n < 0 ? '\u2212' : ''); }

  // ---- rendering -----------------------------------------------------------
  // Minimal for now: the option list and the standard-features block. The
  // sticky total bar, quantity steppers and export validation arrive in the
  // next task; this renders enough for the switcher and state to be real.
  RMC.renderAll = function (ctx) {
    var host = document.querySelector('[data-rmc-options]');
    var choiceHost = document.querySelector('[data-rmc-choices]') || host;
    if (!host) { return; }
    host.textContent = '';
    if (choiceHost !== host) { choiceHost.textContent = ''; }

    // No rig chosen: show the question and hide everything that would imply one.
    var root = document.querySelector('[data-rmc-root]');
    if (root) { root.setAttribute('data-rmc-state', ctx.model ? 'chosen' : 'choosing'); }
    var prompt = document.querySelector('[data-rmc-prompt]');
    var bar = document.querySelector('[data-rmc-bar]');
    var feat = document.querySelector('[data-rmc-features]');
    if (!ctx.model) {
      if (prompt) { prompt.hidden = false; }
      if (bar) { bar.hidden = true; }
      if (feat) { feat.textContent = ''; feat.hidden = true; }
      RMC.renderSwitcher(ctx);
      return;
    }
    if (prompt) { prompt.hidden = true; }
    if (bar) { bar.hidden = false; }
    if (feat) { feat.hidden = false; }

    // Spec section 4 puts the pick-one groups above the upgrades: they are the
    // questions that BLOCK export, and burying them under fifty optional
    // upgrades means the dialog can name what is missing while the customer has
    // no idea where to go and fix it.
    var opts = RMC.optionsFor(ctx.catalog, ctx.model);
    var lastGroup = null, lastHost = null;
    opts.forEach(function (o) {
      var grp = ctx.catalog.groups[o.group] || {};
      var host = grp.kind === 'choice' ? choiceHost : document.querySelector('[data-rmc-options]');
      if (o.group !== lastGroup || host !== lastHost) {
        lastGroup = o.group; lastHost = host;
        var g = ctx.catalog.groups[o.group];
        var head = el('h3', 'rmc__group-h', (g && g.title) || o.group);
        // A swatch group prices every colour the same, so the figure belongs on
        // the heading, in the column every other price sits in — not captioned
        // twelve times, and not adrift in a note.
        var gprice = swatchPrice(ctx, o.group);
        if (gprice) { head.appendChild(el('span', 'rmc__group-price', gprice)); }
        host.appendChild(head);
        var gnote = groupNote(ctx, o.group);
        if (gnote) { host.appendChild(el('p', 'rmc__group-note', gnote)); }
        var pnote = swatchPriceNote(ctx, o.group);
        if (pnote) { host.appendChild(el('p', 'rmc__group-note', pnote)); }
      }
      var group = ctx.catalog.groups[o.group] || {};

      // A floor colour is something you look at, not a word you read, so a
      // swatch group renders as pictures. Exclusive and optional: one floor, or
      // the standard one, never two.
      if (group.kind === 'swatch') {
        var grid = host.querySelector('[data-rmc-swatches="' + o.group + '"]');
        if (!grid) {
          grid = el('div', 'rmc__swatches');
          grid.setAttribute('data-rmc-swatches', o.group);
          host.appendChild(grid);
        }
        // The standard sits on its own row above a divider that carries the
        // price of everything below it, so "what it comes with" and "what a
        // change costs" are two separate statements rather than one list.
        var isStd = o.id === RMC.standardOf(ctx.catalog, o.group, ctx.model);
        if (!isStd && !grid.querySelector('.rmc__swatch-sep')) {
          var sep = el('div', 'rmc__swatch-sep');
          sep.appendChild(el('span', null, ctx.swatchOtherLabel || 'Other colours'));
          var pp = RMC.price(o.price);
          if (pp > 0) { sep.appendChild(el('span', 'rmc__swatch-sep-p', '+' + money(pp))); }
          grid.appendChild(sep);
        }
        var chosen = !!ctx.build.qty[o.id];
        var tile = el('button', 'rmc__swatch' + (chosen ? ' is-on' : '') +
          (isStd ? ' is-std' : ''));
        tile.type = 'button';
        tile.setAttribute('data-rmc-option', o.id);
        tile.setAttribute('aria-pressed', String(chosen));
        var src = (ctx.assets && ctx.assets[o.image]) || '';
        if (src) {
          var sw = image(src, 'rmc__swatch-img', o.name);
          sw.loading = 'lazy';
          tile.appendChild(sw);
        } else {
          tile.appendChild(el('span', 'rmc__swatch-img rmc__swatch-img--none'));
        }
        // the name is its own span so the chosen-tick lands beside it rather
        // than below the Standard tag, on a line of its own
        var cap = el('span', 'rmc__swatch-name');
        cap.appendChild(el('span', 'rmc__swatch-label', o.name));
        if (o.note) { cap.appendChild(el('span', 'rmc__swatch-tag', o.note)); }
        tile.appendChild(cap);
        tile.addEventListener('click', function () { RMC.app.chooseSwatch(o.group, o.id); });
        grid.appendChild(tile);
        return;
      }

      var row = el('label', 'rmc__opt');
      row.setAttribute('data-rmc-option', o.id);
      if (group.kind === 'text') {
        row.appendChild(el('span', 'rmc__opt-mark'));
      } else if (group.kind === 'qty') {
        row.appendChild(RMC.stepper(ctx, o, group));
      } else {
        var input = document.createElement('input');
        // 'one' is a checkbox, not a radio, on purpose: a rig takes at most one
        // front bumper but it does not have to take any, and a radio the
        // customer has clicked can never be un-clicked.
        input.type = group.kind === 'choice' ? 'radio' : 'checkbox';
        if (group.kind === 'choice') { input.name = 'rmc-' + o.group; }
        input.checked = !!ctx.build.qty[o.id];
        input.addEventListener('change', function () {
          if (group.kind === 'choice') { RMC.app.chooseInGroup(o.group, o.id); }
          else if (group.kind === 'one') {
            RMC.app.chooseInGroup(o.group, input.checked ? o.id : null);
          } else { RMC.app.toggleById(o.id); }
        });
        row.appendChild(input);
      }

      // A part the customer cannot picture is a part they do not pick. The slot
      // is rendered whether or not a photo exists yet, so the column of names
      // stays straight while images are still being gathered — a list that
      // re-aligns itself as photos land looks broken the whole time it fills.
      //
      // Off unless the template asks for it. This file and the script are shared
      // by every page built on this section, so an ungated slot would put an
      // empty tile on the live configurator the moment it shipped. The dev
      // template turns it on; live opts in once its photos are in.
      // A write-in request is not a part, so it never gets a slot.
      if (ctx.showThumbs && group.kind !== 'text') {
        var thumb = el('span', 'rmc__opt-thumb');
        var tsrc = (ctx.assets && ctx.assets[o.image]) || '';
        if (tsrc) {
          var timg = image(tsrc, 'rmc__opt-thumb-img', o.name);
          timg.loading = 'lazy';
          thumb.appendChild(timg);
        } else {
          thumb.className = 'rmc__opt-thumb rmc__opt-thumb--none';
        }
        row.className = 'rmc__opt rmc__opt--thumbed';
        row.appendChild(thumb);
      }

      var body = el('span', 'rmc__opt-body');
      body.appendChild(el('span', 'rmc__opt-name', o.name));
      RMC.paragraphs(o.description).forEach(function (para) {
        body.appendChild(el('span', 'rmc__opt-desc', para));
      });
      // for a written request the note IS the field's placeholder, so showing it
      // as a note line as well just says the same thing twice
      if (o.note && group.kind !== 'text') {
        body.appendChild(el('span', 'rmc__opt-note', '* ' + o.note));
      }
      row.appendChild(body);

      if (group.kind === 'text') {
        var field = document.createElement('input');
        field.type = 'text';
        field.className = 'rmc__opt-text';
        field.setAttribute('data-rmc-text', o.id);
        field.placeholder = o.note || 'Tell us what you have in mind';
        field.value = (ctx.build.text && ctx.build.text[o.id]) || '';
        field.addEventListener('input', function () { RMC.app.setTextById(o.id, field.value); });
        body.appendChild(field);
        // The figure is the material-change charge and totals() adds it once the
        // field has something in it, so it is shown the same way as any other
        // price. "from +" read as an estimate for a line that is not one.
        row.appendChild(el('span', 'rmc__opt-price rmc__opt-price--words',
          o.price ? RMC.priceLabel(o.price) : 'Quoted'));
      } else {
        row.appendChild(el('span', 'rmc__opt-price', RMC.priceLabel(o.price)));
      }
      host.appendChild(row);
    });

    RMC.renderFeatures(ctx);
    RMC.renderSwitcher(ctx);
    if (RMC.renderBar) { RMC.renderBar(ctx); }
    if (RMC.renderSheet) { RMC.renderSheet(ctx); }
  };

  // What a group's heading says about itself when its steppers will not move.
  function groupNote(ctx, gid) {
    var g = ctx.catalog.groups[gid];
    if (!g) { return ''; }
    if (!RMC.needsMet(ctx.build, ctx.catalog, gid, ctx.model)) {
      var need = ctx.catalog.groups[g.needs];
      return g.needsNote ||
        ('Add a ' + ((need && need.title) || 'required option') + ' first.');
    }
    if (RMC.groupCount(ctx.build, gid, ctx.catalog) === 1) {
      var held = RMC.dependentsOn(ctx.catalog, gid).filter(function (d) {
        return RMC.groupCount(ctx.build, d, ctx.catalog) > 0;
      });
      if (held.length) {
        var dep = ctx.catalog.groups[held[0]];
        return g.heldNote || ('Remove the ' +
          String((dep && dep.title) || 'items').toLowerCase() + ' first to take the last one off.');
      }
    }
    return '';
  }

  // Twelve tiles each captioned "+$2,500" is noise. Where a swatch group prices
  // every colour the same — which is the point of a material change — say it
  // once, under the heading.
  // The one price every colour in the group shares, or nothing if they differ.
  function swatchPrice(ctx, gid) {
    var g = ctx.catalog.groups[gid];
    if (!g || g.kind !== 'swatch') { return ''; }
    var prices = {};
    RMC.optionsFor(ctx.catalog, ctx.model).forEach(function (o) {
      if (o.group === gid) { prices[String(o.price)] = true; }
    });
    var keys = Object.keys(prices);
    if (keys.length !== 1) { return ''; }
    var p = RMC.price(keys[0]);
    return p > 0 ? '+' + money(p) : (keys[0] || 'No charge');
  }

  function swatchPriceNote(ctx, gid) {
    var g = ctx.catalog.groups[gid];
    return (g && g.kind === 'swatch') ? (g.needsNote || '') : '';
  }

  RMC.stepper = function (ctx, o, group) {
    var n = ctx.build.qty[o.id] || 0;
    var used = RMC.groupCount(ctx.build, o.group, ctx.catalog);
    var cap = RMC.capFor(ctx.catalog, o.group, ctx.model);
    var met = RMC.needsMet(ctx.build, ctx.catalog, o.group, ctx.model);
    var strands = used - 1 === 0 && RMC.dependentsOn(ctx.catalog, o.group)
      .some(function (d) { return RMC.groupCount(ctx.build, d, ctx.catalog) > 0; });
    var wrap = el('span', 'rmc__qty');
    var minus = el('button', 'rmc__qty-btn', '\u2212');
    minus.type = 'button'; minus.disabled = n === 0 || strands;
    minus.addEventListener('click', function (e) {
      e.preventDefault(); RMC.app.setQtyById(o.id, n - 1);
    });
    var out = el('span', 'rmc__qty-n', String(n));
    var plus = el('button', 'rmc__qty-btn', '+');
    plus.type = 'button';
    // The cap belongs to the group AND to the rig, so the + that has to be
    // disabled is every line's + once the group is full for THIS rig — not just
    // the one being clicked, and not at the Baja's number on a Loft.
    plus.disabled = !met || (cap != null && used >= cap);
    plus.addEventListener('click', function (e) {
      e.preventDefault(); RMC.app.setQtyById(o.id, n + 1);
    });
    wrap.appendChild(minus); wrap.appendChild(out); wrap.appendChild(plus);
    return wrap;
  };

  RMC.renderBar = function (ctx) {
    var bar = document.querySelector('[data-rmc-bar]');
    if (!bar) { return; }
    var t = RMC.totals(ctx.build, ctx.catalog, ctx.base);
    var set = function (sel, text) {
      var n = bar.querySelector(sel); if (n) { n.textContent = text; }
    };
    set('[data-rmc-model-name]', ctx.name || ctx.model);
    set('[data-rmc-base]', money(t.base));
    set('[data-rmc-upgrades]', signOf(t.upgrades) + money(t.upgrades));
    set('[data-rmc-total]', money(t.total));
  };

  RMC.renderSheet = function (ctx) {
    var host = document.querySelector('[data-rmc-sheet]');
    if (!host) { return; }
    host.textContent = '';
    var t = RMC.totals(ctx.build, ctx.catalog, ctx.base);
    var c = ctx.customer || {};

    // The masthead: the rig's mark on the left, the house wordmark on the right,
    // on the band colour — the same lockup as the paper order forms, so the sheet
    // a customer emails in looks like the one a dealer would hand them.
    var band = el('div', 'rmcs__band');
    var markSrc = (ctx.marks && ctx.marks[ctx.model]) || '';
    if (markSrc) {
      band.appendChild(image(markSrc, 'rmcs__band-mark', ctx.name || ctx.model));
    } else {
      band.appendChild(el('span', 'rmcs__band-text',
        String(ctx.name || ctx.model || '').toUpperCase()));
    }
    if (ctx.wordmark) {
      band.appendChild(image(ctx.wordmark, 'rmcs__band-brand', 'Rossmönster'));
    }
    host.appendChild(band);

    var head = el('div', 'rmcs__head');
    head.appendChild(el('h2', 'rmcs__title', '2027 ' + (ctx.name || ctx.model) + ' Order Form'));
    host.appendChild(head);

    var who = el('div', 'rmcs__who');
    var name = [c.firstname, c.lastname].filter(Boolean).join(' ');
    [['Customer Name', name], ['Customer Phone', c.phone || ''],
     ['Customer Email', c.email || ''], ['Send to', 'sales@rossmonster.com']
    ].forEach(function (pair) {
      var f = el('div', 'rmcs__field');
      f.appendChild(el('span', 'rmcs__field-lab', pair[0]));
      f.appendChild(el('span', 'rmcs__field-val', pair[1] || '\u00a0'));
      who.appendChild(f);
    });
    host.appendChild(who);

    var feat = el('div', 'rmcs__feat');
    var lines = (ctx.catalog.features && ctx.catalog.features[ctx.model]) || [];
    var col = null;
    lines.forEach(function (line) {
      var s = String(line).trim();
      if (!s) { return; }
      if (s.charAt(0) === '#') {
        col = el('div', 'rmcs__feat-col');
        col.appendChild(el('h4', 'rmcs__feat-h', s.replace(/^#\s*/, '')));
        feat.appendChild(col);
        return;
      }
      if (!col) { col = el('div', 'rmcs__feat-col'); feat.appendChild(col); }
      col.appendChild(el('div', 'rmcs__feat-item', '· ' + s.replace(/^[·\-\u2022]\s*/, '')));
    });
    host.appendChild(feat);

    var sel = el('div', 'rmcs__sel');
    sel.appendChild(el('h4', 'rmcs__feat-h', 'Selections'));
    var picked = RMC.optionsFor(ctx.catalog, ctx.model).filter(function (o) {
      return ctx.build.qty[o.id];
    });
    if (!picked.length) {
      sel.appendChild(el('div', 'rmcs__line', 'No upgrades selected.'));
    } else {
      picked.forEach(function (o) {
        var n = ctx.build.qty[o.id];
        var row = el('div', 'rmcs__line');
        // "Sterling Oak" alone does not say what it is; "Flooring: Sterling Oak" does
        var g = ctx.catalog.groups[o.group];
        var label = (g && g.kind === 'swatch' && g.title) ? g.title + ': ' + o.name : o.name;
        row.appendChild(el('span', null, (n > 1 ? n + ' × ' : '') + label));
        var p = RMC.price(o.price) * n;
        row.appendChild(el('span', 'rmcs__line-p',
          p === 0 ? (o.price || 'No charge') : RMC.priceLabel(String(p))));
        sel.appendChild(row);
      });
    }
    host.appendChild(sel);

    var written = Object.keys(ctx.build.text || {});
    if (written.length) {
      var cw = el('div', 'rmcs__sel');
      cw.appendChild(el('h4', 'rmcs__feat-h', 'Custom requests'));
      RMC.optionsFor(ctx.catalog, ctx.model).forEach(function (o) {
        var t = ctx.build.text && ctx.build.text[o.id];
        if (!t) { return; }
        var row = el('div', 'rmcs__line');
        row.appendChild(el('span', null, o.name + ': ' + t));
        row.appendChild(el('span', 'rmcs__line-p',
          RMC.price(o.price) === 0 ? (o.price || 'Quoted') : RMC.priceLabel(o.price)));
        cw.appendChild(row);
      });
      host.appendChild(cw);
    }

    // The paper form runs the terms and signatures down the left and the price
    // box down the right, so the foot is one row, not two stacked blocks.
    var foot = el('div', 'rmcs__foot');
    var left = el('div', 'rmcs__foot-l');
    (ctx.terms || []).forEach(function (text) {
      var row = el('div', 'rmcs__term');
      row.appendChild(el('span', 'rmcs__tick'));
      row.appendChild(el('span', 'rmcs__term-t', text));
      left.appendChild(row);
    });
    var sign = el('div', 'rmcs__sign');
    [['Customer Signature', 'rmcs__sign-f--wide'], ['Date', 'rmcs__sign-f--narrow']]
      .forEach(function (f) {
        var field = el('div', 'rmcs__sign-f ' + f[1]);
        field.appendChild(el('span', 'rmcs__sign-rule'));
        field.appendChild(el('span', 'rmcs__sign-lab', f[0]));
        sign.appendChild(field);
      });
    left.appendChild(sign);
    foot.appendChild(left);

    var box = el('div', 'rmcs__box');
    [['MSRP', ctx.msrp ? money(ctx.msrp) : '', true],
     ['Adventure Ready Price', money(t.base), false],
     ['Upgrades', signOf(t.upgrades) + money(t.upgrades), false],
     ['Total', money(t.total), false]
    ].forEach(function (r) {
      if (!r[1]) { return; }
      var row = el('div', 'rmcs__box-row' + (r[2] ? ' rmcs__box-row--struck' : ''));
      row.appendChild(el('span', null, r[0]));
      row.appendChild(el('span', 'rmcs__box-fig', r[1]));
      box.appendChild(row);
    });
    foot.appendChild(box);
    host.appendChild(foot);

    host.appendChild(el('p', 'rmcs__send',
      'Email this sheet to sales@rossmonster.com to continue.'));
  };

  // Which spec tab is open. It lives here rather than in the build because it is
  // a view preference, not part of the order — but it does have to survive the
  // re-render that every option click triggers, or the tabs snap back to the
  // first one each time the customer ticks a box.
  var specTab = 0;
  RMC.resetSpecTab = function () { specTab = 0; };

  RMC.renderFeatures = function (ctx) {
    var host = document.querySelector('[data-rmc-features]');
    if (!host) { return; }
    host.textContent = '';
    if (ctx.specs && ctx.specs.length) {
      host.className = 'rmc__feat rmc__feat--specs';
      return renderSpecTabs(host, ctx.specs);
    }
    // Fallback: the transcribed list. Reached when the vehicle page cannot be
    // read — a renamed handle, an offline visitor — and it is stale by design,
    // so it is better than an empty band and worse than the real thing.
    host.className = 'rmc__feat';
    var lines = (ctx.catalog.features && ctx.catalog.features[ctx.model]) || [];
    var col = null;
    lines.forEach(function (line) {
      var t = String(line).trim();
      if (!t) { return; }
      if (t.charAt(0) === '#') {
        col = el('div', 'rmc__feat-col');
        col.appendChild(el('h4', 'rmc__feat-h', t.replace(/^#\s*/, '')));
        host.appendChild(col);
        return;
      }
      if (!col) { col = el('div', 'rmc__feat-col'); host.appendChild(col); }
      col.appendChild(el('div', 'rmc__feat-item', t.replace(/^[·\-•]\s*/, '')));
    });
  };

  function renderSpecTabs(host, specs) {
    if (specTab >= specs.length) { specTab = 0; }
    var bar = el('div', 'rmc__spectabs');
    bar.setAttribute('role', 'tablist');
    specs.forEach(function (tab, i) {
      var b = el('button', 'rmc__spectab', tab.label);
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-rmc-spectab', String(i));
      b.setAttribute('aria-selected', String(i === specTab));
      b.addEventListener('click', function () {
        specTab = i;
        RMC.renderFeatures({ specs: specs });
      });
      bar.appendChild(b);
    });
    host.appendChild(bar);

    var panel = el('div', 'rmc__specpanel');
    specs[specTab].tiles.forEach(function (tile) {
      var t = el('div', 'rmc__spectile');
      if (tile.title) { t.appendChild(el('h4', 'rmc__feat-h', tile.title)); }
      (tile.rows || []).forEach(function (r) {
        var row = el('div', 'rmc__specrow');
        row.appendChild(el('span', 'rmc__specrow-k', r[0]));
        row.appendChild(el('span', 'rmc__specrow-v', r[1]));
        t.appendChild(row);
      });
      (tile.items || []).forEach(function (item) {
        t.appendChild(el('div', 'rmc__feat-item', item));
      });
      panel.appendChild(t);
    });
    host.appendChild(panel);
  }

  // The export dialog. It never blocks silently: if the sheet would be
  // incomplete it says which parts, because "nothing happened" on a button is
  // indistinguishable from a broken page.
  RMC.wireExport = function () {
    var dlg = document.querySelector('[data-rmc-dialog]');
    var btn = document.querySelector('[data-rmc-export]');
    if (!dlg || !btn || btn.__rmcWired) { return; }
    btn.__rmcWired = true;

    var LABEL = { firstname: 'First name', lastname: 'Last name',
                  phone: 'Phone', email: 'Email' };

    function syncFields() {
      var c = RMC.app.customer();
      RMC.customerFields.forEach(function (f) {
        var input = dlg.querySelector('[name="' + f + '"]');
        if (input && !input.value) { input.value = c[f] || ''; }
      });
    }
    var formMode = !!document.querySelector('[data-rmc-hsform]');

    function showMissing() {
      // In form mode the contact details belong to HubSpot, so the only thing
      // this page can still be waiting on is the build itself.
      var v = formMode ? RMC.app.validate() : RMC.app.validateExport();
      if (formMode) { v = { ok: v.ok, missing: v.missing, groups: v.missing }; }
      var box = dlg.querySelector('[data-rmc-missing]');
      if (box) {
        box.textContent = '';
        RMC.exportBlocked(v, LABEL).forEach(function (line) {
          box.appendChild(el('span', 'rmc__missing-line', line));
        });
      }
      var go = dlg.querySelector('[data-rmc-print]');
      if (go) { go.disabled = !v.ok; }
      return v;
    }

    btn.addEventListener('click', function () {
      if (formMode) { RMC.loadHubSpotForm(); } else { syncFields(); }
      showMissing();
      if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    });

    dlg.addEventListener('input', function (e) {
      var f = e.target.getAttribute && e.target.getAttribute('name');
      if (RMC.customerFields.indexOf(f) < 0) { return; }
      var patch = {}; patch[f] = e.target.value;
      RMC.app.setCustomer(patch);
      showMissing();
    });

    var closeBtn = dlg.querySelector('[data-rmc-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
      });
    }

    var printBtn = dlg.querySelector('[data-rmc-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        if (!showMissing().ok) { return; }
        // keepalive is what carries this through whatever happens next; it does
        // not need to be awaited.
        // Two independent sends, neither awaited: keepalive carries both through
        // whatever print does next, and a failure in either must not cost the
        // customer the sheet they came for.
        RMC.app.sendLead();
        RMC.app.notifySales();
        if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
        window.print();
      });
    }
  };

  // The real HubSpot form lives in a cross-origin iframe, so the page cannot
  // read it, submit it, or style it. What it can do is listen: the embed
  // dispatches hs-form-event:on-submission:success on this window when HubSpot
  // has accepted the submission. That is the cue to print.
  //
  // The event name was read off the real embed, not guessed — the failure case
  // is hs-form-event:on-submission:failed, and acting on the wrong one would
  // print for submissions HubSpot had rejected.
  RMC.wireHubSpotForm = function () {
    var host = document.querySelector('[data-rmc-hsform]');
    if (!host || host.__rmcWired) { return; }
    host.__rmcWired = true;
    root.addEventListener('hs-form-event:on-submission:success', function () {
      var dlg = document.querySelector('[data-rmc-dialog]');
      if (dlg) { if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); } }
      // a tick, so the dialog is gone before the print view is composed
      root.setTimeout(function () { root.print(); }, 60);
    });
  };

  // Loaded when the dialog is first opened rather than on page load: it is a
  // third-party script and most visitors never reach the export.
  RMC.loadHubSpotForm = function () {
    var host = document.querySelector('[data-rmc-hsform]');
    if (!host || host.__rmcLoaded) { return; }
    if (!host.getAttribute('data-form-id') || !host.getAttribute('data-portal-id')) { return; }
    host.__rmcLoaded = true;
    host.className += ' hs-form-frame';
    var src = host.getAttribute('data-embed-src');
    var tag = document.createElement('script');
    tag.src = src;
    tag.defer = true;
    document.body.appendChild(tag);
  };

  RMC.renderSwitcher = function (ctx) {
    var host = document.querySelector('[data-rmc-switcher]');
    if (!host) { return; }
    [].slice.call(host.querySelectorAll('[data-rmc-model]')).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-rmc-model') === ctx.model));
    });
    RMC.renderBack(ctx);
  };

  // The way back to the rig's own page. A customer deep in the option list has
  // left the photographs, the specs and the floorplans behind, and the browser
  // back button is the only route back once they have clicked around — which is
  // a dead end if they arrived here from a campaign link.
  //
  // The URL comes from spec_sources, where each rig's page is already named as
  // the place its specs are read from. A second list of rig URLs would be a
  // second thing to keep right.
  RMC.renderBack = function (ctx) {
    var back = document.querySelector('[data-rmc-back]');
    if (!back) { return; }
    var src = ctx.specSources && ctx.specSources[ctx.model];
    if (!ctx.model || !src || !src.path) { back.hidden = true; return; }
    back.hidden = false;
    back.setAttribute('href', src.path);
    back.textContent = (back.getAttribute('data-rmc-back') || 'Back to the {rig}')
      .replace('{rig}', ctx.name || ctx.model);
  };

  // ---- app -----------------------------------------------------------------
  RMC.app = (function () {
    var catalog = null, models = [], names = {}, bases = {}, msrp = {};
    var state = {}, current = null, marks = {}, wordmark = '', terms = [], hubspot = {};
    // undefined = never asked, null = asked and got nothing, array = the specs
    var specSources = {}, specCache = {}, assets = {}, showThumbs = false;

    function storage() {
      // Reading the property itself throws in some locked-down browsers, which
      // is why this is wrapped and not just passed straight through.
      try { return root.localStorage; } catch (e) { return null; }
    }
    function ctx() {
      return { model: current, build: build(), catalog: catalog,
               base: bases[current], msrp: msrp[current], name: names[current],
               specs: specCache[current] || null,
               marks: marks, wordmark: wordmark, terms: terms,
               specSources: specSources, assets: assets,
               showThumbs: showThumbs,
               customer: state.__customer || {} };
    }
    function build() {
      if (!current) { return RMC.emptyBuild(null); }
      if (!state[current]) { state[current] = RMC.emptyBuild(current); }
      if (!state[current].text) { state[current].text = {}; }
      // A rig ships with a standard floor, so the build carries it from the
      // start — an empty swatch group reads as "not decided", which is wrong.
      if (catalog) { RMC.applyStandards(state[current], catalog, current); }
      return state[current];
    }
    function commit(result) {
      RMC.saveState(state, storage());
      RMC.renderAll(ctx());
      return result;
    }

    // One request per rig per visit, and never a second one for a rig that came
    // back empty: a missing vehicle page is a missing vehicle page, and retrying
    // on every click would hammer it for nothing.
    function ensureSpecs() {
      var m = current;
      if (!m || specCache[m] !== undefined) { return; }
      specCache[m] = null;
      RMC.loadSpecs(specSources[m]).then(function (specs) {
        if (!specs) { return; }
        specCache[m] = specs;
        if (current === m) { RMC.renderAll(ctx()); }
      });
    }

    function init() {
      var island = document.querySelector('[data-rmc-catalog]');
      if (!island) {
        // Every Liquid-side failure lands here or in the catch below, and the
        // symptom is an inert page. Saying so turns a long debugging session
        // into a glance at the console.
        if (root.console) { console.warn('[rm-configurator] no catalogue island in the page'); }
        return;
      }
      var data;
      try {
        data = JSON.parse(island.textContent);
      } catch (e) {
        if (root.console) { console.warn('[rm-configurator] catalogue JSON is invalid:', e); }
        return;
      }

      var m = RMC.buildModels(data.modelRows || []);
      models = m.models; names = m.names; bases = m.bases; msrp = m.msrp;
      catalog = RMC.buildCatalog(data.groups || []);
      if (catalog.duplicates.length && root.console) {
        // Reported, not merely recorded: a collision means a merchant typed two
        // products whose names slug alike, and the numbered id is a survival
        // measure, not a fix.
        console.warn('[rm-configurator] duplicate option ids:', catalog.duplicates.join(', '));
      }
      catalog.features = data.features || {};
      specSources = RMC.specSources(data.specSources || '');
      marks = data.marks || {};
      wordmark = data.wordmark || '';
      terms = data.terms || [];
      hubspot = data.hubspot || {};
      assets = data.assets || {};
      showThumbs = !!data.showThumbs;

      state = RMC.loadState(storage());
      for (var m in state) {
        if (m === '__customer') { continue; }   // a contact record, not a build
        if (!state[m] || !state[m].qty) { delete state[m]; continue; }
        // A merchant may have deleted options since this build was saved.
        state[m] = RMC.pruneBuild(state[m], catalog);
      }

      // No rig named, or one that is not on the page: the page asks rather than
      // choosing for the customer. A saved build is restored the moment they pick.
      current = RMC.modelFromQuery(root.location.search, models);

      var sw = document.querySelector('[data-rmc-switcher]');
      if (sw) {
        sw.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('[data-rmc-model]') : null;
          if (btn) { api.switchModel(btn.getAttribute('data-rmc-model')); }
        });
      }
      RMC.wireExport();
      RMC.wireHubSpotForm();
      RMC.renderAll(ctx());
      ensureSpecs();
    }

    var api = {
      init: init,
      model: function () { return current; },
      models: function () { return models.slice(); },
      build: build,
      catalog: function () { return catalog; },
      base: function () { return bases[current]; },
      msrp: function () { return msrp[current]; },
      totals: function () { return RMC.totals(build(), catalog, bases[current]); },
      groupCount: function (g) { return RMC.groupCount(build(), g, catalog); },
      switchModel: function (m) {
        current = RMC.resolveModel(m, models, { allowNone: true });
        RMC.resetSpecTab();
        var r = commit({ ok: true });
        ensureSpecs();
        return r;
      },
      specs: function () { return specCache[current] || null; },
      toggleById: function (id) { return commit(RMC.toggle(build(), id, catalog)); },
      setQtyById: function (id, n) { return commit(RMC.setQty(build(), id, n, catalog)); },
      chooseInGroup: function (g, id) { return commit(RMC.choose(build(), g, id, catalog)); },
      chooseSwatch: function (g, id) {
        return commit(RMC.chooseSwatch(build(), g, id, catalog, current));
      },
      setTextById: function (id, value) {
        var r = RMC.setText(build(), id, value);
        RMC.saveState(state, storage());   // no re-render: it would kill focus mid-typing
        if (RMC.renderSheet) { RMC.renderSheet(ctx()); }
        if (RMC.renderBar) { RMC.renderBar(ctx()); }
        return r;
      },
      validate: function () { return RMC.validateBuild(build(), catalog, current); },
      customer: function () { return state.__customer || {}; },
      setCustomer: function (obj) {
        state.__customer = Object.assign({}, state.__customer || {}, obj || {});
        return commit({ ok: true });
      },
      sendLead: function () {
        return RMC.submitLead(state.__customer || {}, ctx(), {
          portal: hubspot.portal, form: hubspot.form, region: hubspot.region,
          fieldMap: RMC.fieldMap(hubspot.fieldMap),
          modelMap: RMC.fieldMap(hubspot.modelMap),
          modelField: hubspot.modelField, buildField: hubspot.buildField,
          hutk: RMC.cookie('hubspotutk', root.document.cookie),
          pageUri: root.location.href, pageName: root.document.title
        }).then(function (r) {
          // "not configured" is a choice, not a fault. Anything else is a lead
          // that did not arrive, and nobody finds that by watching the CRM.
          if (!r.ok && r.reason !== 'not configured' && root.console) {
            console.warn('[rm-configurator] lead not sent to HubSpot:', r);
          }
          return r;
        });
      },
      notifySales: function () {
        return RMC.notifySales(state.__customer || {}, ctx(), {
          url: hubspot.notifyUrl,
          rig: names[current] || current,
          pageUri: root.location.href,
          pageUrl: root.location.href
        }).then(function (r) {
          if (!r.ok && r.reason !== 'not configured' && root.console) {
            console.warn('[rm-configurator] sales notification failed:', r);
          }
          return r;
        });
      },
      validateExport: function () {
        return RMC.validateExport(build(), catalog, current, state.__customer || {});
      }
    };
    return api;
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', RMC.app.init);
  } else {
    RMC.app.init();
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);
